import { useCohort } from "@/components/user-context";

import { LoggedInJiraNewUser } from "../components/logged-in-jira-new-user";

import { LoggedInJiraFreeExistingSitesUser } from "./existing-sites-user";
import { LoggedInJiraFreeManagedUser } from "./managed-user";
import { LoggedInJiraFreeWeekOneUser } from "./week-one-user";

export const LoggedInJiraFree = () => {
    const cohort = useCohort();

    if (cohort === "new-user") {
        return <LoggedInJiraNewUser />;
    }

    if (cohort === "managed-user") {
        return <LoggedInJiraFreeManagedUser />;
    }

    if (cohort === "week-one-user") {
        return <LoggedInJiraFreeWeekOneUser />;
    }

    if (cohort) {
        return <LoggedInJiraFreeExistingSitesUser />;
    }

    return null;
};
